( function() {
	// Set a class to determine if internal menu should be
	// displayed on mobile screens
	var mainContainer = document.getElementById( 'secondary-header' );
	var internalNav = document.getElementById( 'js-menu-internal-wrapper' );
	var menuItems;
	var hero = document.getElementsByClassName( 'hero-single' );
	var displayMenu = false;

	// if secondary nav exists
	if ( internalNav ) {
		menuItems = internalNav.getElementsByClassName( 'menu-item' );
		for ( var i = 0; i < menuItems.length; i++ ) {
			if ( menuItems[i].classList.contains( 'current-menu-item' ) && menuItems[i].classList.contains( 'menu-item-has-children' ) ) {
				displayMenu = true;
			} else if ( menuItems[i].classList.contains( 'current-menu-ancestor' ) ) {
				displayMenu = true;
			}
		}
	}

	if ( mainContainer ) {
		// add class based upon display logic.
		if ( displayMenu ) {
			mainContainer.classList.add( 'show-menu' );
		} else {
			mainContainer.classList.add( 'hide-menu' );
		}

		// add a class to do specific styling if the hero doesn't exist.
		if ( hero && hero.length > 0 ) {
			mainContainer.classList.add( 'has-hero' );
		} else {
			mainContainer.classList.add( 'no-hero' );
		}
	}

} )();
